const request = {
    invalid_input: 'Nieprawidłowe dane wejściowe. {{details}}',
    general: 'Wystąpił błąd żądania.',
    /** UNTRANSLATED */
    range_not_satisfiable: 'Range not satisfiable.',
};
export default Object.freeze(request);
